import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/authentication/services/auth.service';
import { AccountsService } from 'src/app/configurations/services/accounts.service';
import { UsersService } from 'src/app/configurations/services/users.service';
import { PermissionsService } from 'src/app/permissions/services/permissions.service';
import { RouterLink } from '../models/router-link.model';

const productsToShowPermissions = [ 
  { name: "Plugin Manufacturer Design Auditor", library: "3179"}
];

@Component({
  selector: 'navmenu',
  templateUrl: './navmenu.component.html',
  styleUrls: ['./navmenu.component.scss']
})

export class NavmenuComponent implements OnInit {
  loading: boolean = false;
  shouldShowSideNav: boolean = false;
  routerLinks: RouterLink[] = [
    {
      route: "/projects",
      routerLinkActiveOptions: {
        exact: true
      },
      iconName: "work"
    },
    // {
    //   route: "/customers",
    //   routerLinkActiveOptions: {
    //     exact: false
    //   },
    //   iconName: "account_circle",

    // },
    // {
    //   route: "/charts",
    //   routerLinkActiveOptions: {
    //     exact: false
    //   },
    //   iconName: "pie_chart"
    // },
    {
      route: "/all-charts",
      routerLinkActiveOptions: {
        exact: false
      },
      iconName: "bar_chart"
    },

    {
      route: "/configurations",
      routerLinkActiveOptions: {
        exact: false
      },
      iconName: "settings"
    },
    {
      route: "/account-configuration",
      routerLinkActiveOptions: {
        exact: false
      },
      iconName: "settings_applications"
    },
  ]
  constructor(
    private usersService: UsersService,
    private accountsService: AccountsService,
    private authService: AuthService,
    private permissionService: PermissionsService) { }

  ngOnInit() {
    this.usersService.checkIsAdmin().subscribe({
      error: (err) => {
        if (err.status === 401) {
          this.authService.login();
        }
      }
    });

    const userAccounts = this.authService.getAccounts();
    const defaultAccount = this.authService.getDefaultAccountId();
    this.accountsService.setDefaultAccount(userAccounts, defaultAccount);

    let account = localStorage.getItem("acc");
    this.permissionService.getProductsLicenseOwnership(account).subscribe({
      next: ((isProductOwnership: boolean) => {
        this.permissionService.getLicenseProducts(account).subscribe(licenseProducts => {
          const showPermissionFilter = (product) => productsToShowPermissions.some(x => x.library == product.library);
          const hasManufacturerAuditor = licenseProducts.filter(showPermissionFilter);
          if (isProductOwnership || hasManufacturerAuditor) {
            this.showPermissionButton(true);
          }
        })
      })
    })
  }

  showPermissionButton(hasPermission) {
    if (hasPermission) {
      let permissionLink = {
        route: "/permissions",
        routerLinkActiveOptions: {
          exact: false
        },
        iconName: "account_circle"
      }

      let configurationLink = {
        route: "/configurations",
        routerLinkActiveOptions: {
          exact: false
        },
        iconName: "settings"
      }

      this.routerLinks[2] = permissionLink;
      this.routerLinks = [...this.routerLinks, configurationLink]
    }
  }

  public showPermissions(): void {
    let permissionItem =
    {
      route: "/permissions",
      routerLinkActiveOptions: {
        exact: false
      },
      iconName: "account_circle"
    };
    this.routerLinks.splice(2, 0, permissionItem);
  }

  public showAllCharts(): void {
    let allChartsItem =
    {
      route: "/all-charts",
      routerLinkActiveOptions: {
        exact: false
      },
      iconName: "bar_chart"
    };
    this.routerLinks.splice(2, 0, allChartsItem);
  }
}